module.exports = __webpack_public_path__ + "assets/img/ico_apple.ffbbee9c.svg";